import ShopHeader from "@/components/shop/ShopHeader";
import FadeInSection from "@/components/animations/FadeInSection";

export default function ShopSkeleton() {
    return (
        <>
            <ShopHeader showMenu showSearch showFavorite showCart showProfile />

            <div className="pt-4 md:pt-16 pb-16 min-h-screen bg-cream dark:bg-dark transition-colors duration-300">
                <FadeInSection>
                    <div className="max-w-full mx-auto px-4 md:px-6">
                        {/* ── MOBILE SKELETON ──────────────────────────────── */}
                        <div className="md:hidden">
                            {/* Banner */}
                            <div className="w-full aspect-video bg-black/5 dark:bg-white/5 rounded-2xl animate-pulse mb-5 border border-gold/10" />

                            {/* Categories */}
                            <div className="flex gap-2 mb-4 overflow-hidden">
                                {[1, 2, 3, 4].map((i) => (
                                    <div
                                        key={i}
                                        className="h-8 w-20 bg-black/5 dark:bg-white/5 rounded-full animate-pulse shrink-0"
                                    />
                                ))}
                            </div>

                            {/* Toolbar */}
                            <div className="flex items-center justify-between mb-4">
                                <div className="h-6 w-24 bg-black/5 dark:bg-white/5 rounded animate-pulse" />
                                <div className="h-8 w-8 bg-black/5 dark:bg-white/5 rounded-md animate-pulse" />
                            </div>

                            {/* Products Grid */}
                            <div className="grid grid-cols-2 gap-3">
                                {[1, 2, 3, 4].map((i) => (
                                    <ShopProductSkeleton key={i} />
                                ))}
                            </div>
                        </div>

                        {/* ── DESKTOP SKELETON ─────────────────────────────── */}
                        <div className="hidden md:flex gap-8">
                            {/* Left Sidebar */}
                            <div className="w-64 shrink-0">
                                {/* Desktop Categories */}
                                <div className="h-6 w-32 bg-black/5 dark:bg-white/5 rounded animate-pulse mb-4" />
                                <div className="flex flex-col gap-2 mb-8">
                                    {[1, 2, 3, 4, 5].map((i) => (
                                        <div
                                            key={i}
                                            className="h-5 w-40 bg-black/5 dark:bg-white/5 rounded animate-pulse"
                                        />
                                    ))}
                                </div>
                                {/* Filters */}
                                <div className="h-6 w-24 bg-black/5 dark:bg-white/5 rounded animate-pulse mb-4" />
                                <div className="h-10 w-full bg-black/5 dark:bg-white/5 rounded-md animate-pulse mb-3" />
                                <div className="h-10 w-full bg-black/5 dark:bg-white/5 rounded-md animate-pulse mb-4" />
                                <div className="h-10 w-full bg-black/5 dark:bg-white/5 rounded-md animate-pulse" />
                            </div>

                            {/* Right Content */}
                            <div className="flex-1 min-w-0">
                                {/* Banner */}
                                <div className="w-full aspect-21/5 bg-black/5 dark:bg-white/5 rounded-2xl animate-pulse mb-8 border border-gold/10" />

                                {/* Toolbar */}
                                <div className="flex items-center justify-between mb-4">
                                    <div className="h-7 w-32 bg-black/5 dark:bg-white/5 rounded animate-pulse" />
                                    <div className="flex gap-2">
                                        <div className="h-10 w-40 bg-black/5 dark:bg-white/5 rounded-md animate-pulse" />
                                        <div className="h-10 w-10 bg-black/5 dark:bg-white/5 rounded-md animate-pulse" />
                                        <div className="h-10 w-10 bg-black/5 dark:bg-white/5 rounded-md animate-pulse" />
                                    </div>
                                </div>

                                {/* Products Grid */}
                                <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
                                    {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                                        <ShopProductSkeleton key={i} />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </FadeInSection>
            </div>
        </>
    );
}

function ShopProductSkeleton() {
    return (
        <div className="bg-white dark:bg-dark-2 rounded-2xl overflow-hidden shadow-sm border border-gold/10 flex flex-col">
            <div className="w-full aspect-5/4 relative overflow-hidden bg-black/5 dark:bg-white/5 animate-pulse" />
            <div className="p-3 md:p-4 flex flex-col grow">
                <div className="h-4 bg-black/10 dark:bg-white/10 rounded w-full animate-pulse mb-2" />
                <div className="h-4 bg-black/10 dark:bg-white/10 rounded w-2/3 animate-pulse mb-3 md:mb-auto" />
                <div className="mt-2 md:mt-3">
                    <div className="h-5 md:h-6 bg-black/10 dark:bg-white/10 rounded w-1/2 animate-pulse mb-1.5" />
                    <div className="h-3 bg-black/10 dark:bg-white/10 rounded w-1/3 animate-pulse" />
                </div>
            </div>
        </div>
    );
}
